const content = {
  backToTop: 'Back to top',
  footer: {
    primaryLabel: 'DISCOVER',
    secondaryLabel1: 'Powered by Global Markets',
    secondaryLabel2: '- EY Knowledge',
    logOut: 'LOGOUT',
    glossary: 'GLOSSARY',
    settings: 'SETTINGS',
    support: 'SUPPORT',
    sendFeedback: 'SEND FEEDBACK',
  },
  homePage: {
    secondaryTitle: 'A smart way of finding and evaluating  data',
    searchBoxPlaceholder: 'Search for data products, data providers and data insights here...',
    requestProduct: 'Request New Data Product',
  },
  homeText: {
    primaryTitle: 'Data Explorer',
    titleHint: 'Data Explorer Home',
  },
  homeFilter: {
    titlefilter: 'Filter your results',
    noResultsTitle: '0 Result(s)',
  },
  homeFilter2: {
    linefilter: '|',
  },
  logoutPage: {
    message: 'Thank you for your request.',
    logoutStatus: 'Success',
    loginBtnLabel: 'Login',
  },
  actionPanel: {
    requestLabel: 'Request Access',
    toastMsg: 'You have successfully copied the URL.',
    shareMsg: 'Open - ',
    emailSubject: 'Data Explorer - ',
  },
  AddTile: {
    toastMsg: 'You have successfully added this item to My Data.',
  },
  filter: {
    resetBtnLabel: '(Clear all)',
  },
  navbar: {
    appsLabel: 'Apps',
    submitLabel: 'Submit',
    submitTooltip: 'Submit your material for inclusion in Discover',
  },
  viewMore: {
    viewMoreLable: 'view-all',
    viewLessLable: 'view-less',
  },
  glossaryPage: {
    title: 'Glossary',
  },
  whatsNew: {
    title: "What's New",
    whatsNewBanner:
      "Just Published: EY's Essential Accounting, Audit and Tax Source's Report! Visit 'What's New?' or",
    whatNewClickHere: '  Click here to read more',
    text: '/whatsNew',
  },
  home: {
    title: 'Home',
    text: '/home',
  },
  allData: {
    title: 'All Data',
    text: '/results',
  },
  requests: {
    title: 'Requests',
    text: '/requests',
    searchPlaceholder: 'Search',
  },
  dashboard: {
    title: 'Dashboard',
    text: '/dashboard',
    registerProduct: 'Register New Data Product',
    myDashboard: 'My Dashboard',
  },
  newJoiner: {
    title: 'New Joiner',
    text: '/newJoiner',
  },
  viewCart: {
    title: 'View Cart',
  },
  registerNewDataProduct: {
    title: 'Register Data Product',
    text: '/registerNewDataProduct',
    viewRequestLink: 'View Request Summary',
    requestSummaryLink: 'Request Summary',
    closeText: 'Close',
    saveText: 'Save',
    requestPublicationText: 'Request Publication',
    moveToDraftText: 'Move to Draft',
    PopupCancelBodyText: 'Do you want to exit the form?',
    PopupConfirmationHeaderText: 'Confirmation',
    CancelPopupYesButton: 'Yes',
    CancelPopupNoButton: 'No',
    actions: {
      submit: {
        header: 'Confirmation',
        body: 'The publication has been submitted to the Governor for approval.',
        buttonText: 'OK',
        defaultClose: false,
      },
      save: {
        header: 'Confirmation',
        body: 'Changes have been saved successfully.',
        buttonText: 'OK',
        defaultClose: true,
      },
      validation: {
        header: 'Form Validation Error',
        body: 'Please review all the tabs and complete all the mandatory fields.',
        buttonText: 'OK',
        defaultClose: true,
      },
      moveToDraft: {
        header: 'Confirmation',
        body: 'Do you want to unpublish this data product by moving it to draft status?',
        confirmBtn: 'Yes',
        cancelBtn: 'No',
        defaultClose: true,
      },
    },
  },
  dataProduct: {
    title: 'Request New Data Product',
    text: '/dataProduct',
    subHeading:
      'Creating a Data Product provides guidance to Consumers and Producers on the high-level questions to answer in the different lifecycle stages of building a Data Product',
    noteText: 'Note: All fields are required to submit the request.',
    viewTitle: 'Review Data Product Request',
  },
  details: {
    download: 'Download',
    goToProvider: 'Go to Data Provider Profile',
    contactTitle: 'Contacts & Support',
    goToWebsite: 'Go to Data Provider Website',
    dataExplorerHome: 'Data Explorer Home',
    clientData: 'Client Data - Account Team',
    access: 'Access',
    websiteLabel: 'Website',
    dashboardLabel: 'Dashboard',
  },
  clientDetails: {
    clientName: 'MDW',
    PopupHeaderText: 'Access',
    contactTitle: 'Contacts & Support',
    AccessButtonText: 'Access',
    AttestButtonText: 'Attest',
    PopupPrimaryButton: 'Yes',
    PopupSecondaryButton: 'No',
    GlobalTaxLink: 'https://www.ey.com/en_us/services/tax/global-tax-platform',
    PopupBodyText:
      'Clicking the Access button will take you to a different system. Do you want to proceed?',
  },
  dataTileType: {
    nonClient: 'Non-Client',
    client: 'MDW',
    subClient: 'TDS',
  },
  resultPage: {
    noResultTitle: 'We could not find any results for your search.',
    noResultDescription: `Suggestions:</br>
      Make sure that all words are spelled correctly.</br>
      Try different keywords.</br>
      Try more general keywords.`,
    noResultInfo: 'Please click here to describe your need in more detail.',
    noResulteMailTo: 'externalcontent@ey.com',
    noResulteMailSubject: 'We could not find any results for your search',
    noResultMailBody: 'Please describe your need in more detail.',
  },
  compareViewPage: {
    title: 'Compare',
    noItemsMessage: {
      description:
        'You currently have no items selected to compare in your cart.  Please select one or more assets from your cart to compare.',
    },
  },
  pageTitle: {
    homePage: 'Data Explorer',
    resultPage: 'Results{searchTerm} | In | Data Explorer',
    detailsPage: '{documentTitle} | Data Explorer Details',
    loginPage: 'Data Explorer Login',
    logoutPage: 'Data Explorer Logout',
    glossaryPage: 'Data Explorer Glossary',
    newJoinerPage: 'Data Explorer New Joiner',
    whatsNewPage: "Data Explorer What's New",
    compareViewPage: 'Compare View',
    recentViewAllPage: 'My Data',
    couldntfind: "Couldn't find what you were searching for?",
    dataProductPage: 'Data Explorer Data Product',
    requestsPage: 'Data Explorer Requests',
    dashboardPage: 'Data Explorer Dashboard',
  },
  requestAccessPopUp: {
    header: 'How data can be used',
    acknowledge: 'Acknowledge',
    closed: 'Closed',
    user: 'Firsttimeuser',
  },
  detailPageNoContent: {
    headerText: 'Content not available',
    bodyText:
      'The link you are accessing is not available. The asset may have been archived, the link is invalid or you don’t have permissions.',
    buttonText: 'Search in Data Explorer',
  },
  cartAndComparePopup: {
    label: 'View Cart',
    emptyMessage: 'Add assets to the cart to compare them side by side',
    compareBtnLabel: 'Compare',
    clearAllBtnLabel: 'Clear all',
  },
  bannerImage: {
    homeIconHint: 'Data Explorer Home',
  },
  cardHover: {
    provider: 'Data Provider',
    datadelivery: 'Data Delivery Method(s)',
    dataProviderImageAlternativeText: 'Dataprovider hover background',
  },
  dropdownmenu: {
    AddtoCart: 'Add to Cart',
    Copyurl: 'Copy URL',
    SendanEmail: 'Send an Email',
    ChatinTeams: 'Share to Teams',
  },
  expandAndCollapse: {
    title: 'title',
  },
  viewmore: {
    title: 'View More',
  },
  viewAll: {
    title: 'View all',
  },
  toggleButtonVisiblity: {
    mostPopular: 'mostpopular',
    topic: 'topic',
    recentlyviewAll: 'recentlyviewedall',
    recentlyviewed: 'recentlyviewed',
    resultpage: 'resultpage',
    listpage: 'listpage',
  },
  viewType: {
    listview: 'listview',
    cardview: 'cardview',
  },
  // Release 29.5: added seach query filter by path
  listNames: {
    DiscoverDataAsset: 'DiscoverDataAsset',
    DiscoverDataCollateral: 'DiscoverDataCollateral',
  },
  paths: {
    displayForm: '/DispForm.aspx?ID=',
  },
  ApiRowLimit: {
    popular: 4,
    recentlyView: 50,
    searchResult: 24,
  },
  contactListName: {
    DataAssetContactListName: 'Data Asset Contact',
  },
  contactFields: {
    DataAsset: 'DataAsset',
    categoryDetails: 'categoryDetails',
  },
  registrationModel: {
    title: 'First Time User Access',
    columnField: 'EYKDRegistration',
  },
  recentlyviewedtype: {
    type: 'recentlyviewed',
  },
  firstTimeAccess: {
    line1: 'If this is your first time accessing this data source',
    line2: 'If you have access, click the {buttonLabel} button.',
  },
  Assetpills: {
    All: 'All',
    Products: 'Products',
    Providers: 'Providers',
    Sets: 'Sets',
    managedProperty: 'EYKDAssetType',
  },
  ApiResponseStatus: {
    start: 'START',
    progressing: 'PROGRESSING',
    done: 'DONE',
  },
  pathContent: {
    homePgae: 'HomePage',
    homePage: 'Homepage',
    results: 'results',
    Results: 'Results',
    search: 'SearchPage',
    recentlyViewAll: 'recentlyViewAll',
    recentlyViewAllPage: 'RecentlyviewAllPage',
    recentlyViewPage: 'Recentlyviewed Page',
    recentlyViewed: 'Recentlyviewed',
    copyBitlyLink: 'Copy Bitly Link',
    email: 'Email',
    shareTeam: 'Share to Teams',
    mostpopular: 'Mostpopular',
  },
  ellipsis: {
    homePage: 'Homepage',
    recentlyViewed: 'Recentlyviewed',
    copyBitlyLink: 'Copy URL',
    email: 'Send an Email',
    shareTeam: 'Share to Teams',
    mostpopular: 'Mostpopular',
    addToCart: 'Add to Cart',
    searchResults: 'Search Results',
  },
  contactType: {
    PeopleContact: 'PeopleContact',
    EmailContact: 'EmailContact',
    LinkContact: 'LinkContact',
  },
  roleDescription: {
    roleMaxCharLength: 24,
  },
  noMyData: {
    title: 'No Data',
    message: "There is no data added here yet.\nPlease 'Search' or visit 'All Data'.",
  },
  newDataProductForm: {
    Title: 'DataProduct Form',
    PopupButtonText: 'OK',
    PopupSubmitBodyText: 'Thank you for submitting the request for a new data Product.',
    PopupCancelBodyText: 'Do you want to exit out of the New Data Product Request form?',
    PopupHeaderText: 'Submit Request',
    PopupCancelHeaderText: 'Cancel',
    CancelPopupYesButton: 'Yes',
    CancelPopupNoButton: 'No',
    FieldValidationMessage: 'This field is required. Please enter a value.',
  },
  addRemoveTile: {
    PopupButtonText: 'OK',
    PopupBodyText: 'You are removing a tile from My Data, proceed?',
    PopupHeaderText: 'My Data',
    CancelPopupPrimaryButton: 'Yes',
    CancelPopupSecondaryButton: 'No',
  },
  DPFStatus: {
    FilterDate: '2025-06-01T00:00:00Z', // Added filter date for DPF requests
  },
  requestsTabsIds: {
    accessRequests: 'accessrequests',
    dataProductRequest: 'dataProductRequests',
  },
  requestsTabs: [
    {
      id: 'accessrequests',
      isVisibility: true,
      tabName: 'Access Requests',
    },
    {
      id: 'dataProductRequest',
      isVisibility: true,
      tabName: 'Data Product Requests',
    },
  ],
  producerDashboardTabs: [
    {
      id: 'mydataproducts',
      isVisibility: true,
      mappingId: 'dp',
      tabName: 'My Data Products',
      content: 'My Data Products Content',
    },
    {
      id: 'dataProductRequests',
      isVisibility: true,
      mappingId: 'dpr',
      tabName: 'Data Product Requests',
      content: 'Data Product Requests Content',
    },
  ],
  governorDashboardTabs: [
    {
      id: 'alldataproducts',
      isVisibility: true,
      mappingId: 'dp',
      tabName: 'Data Products',
      content: 'All Data Products Content',
    },
    {
      id: 'dataProductRequests',
      isVisibility: true,
      mappingId: 'dpr',
      tabName: 'Data Product Requests',
      content: 'Data Product Requests Content',
    },
  ],
  registerDataProductDashboardTabs: [
    {
      id: 'visionandstrategy',
      isVisibility: true,
      tabName: 'Vision and Strategy',
      content: 'Vision and Strategy Content',
    },
    {
      id: 'developandtest',
      isVisibility: true,
      tabName: 'Develop and Test',
      content: 'Develop and Test Content',
    },
    {
      id: 'releasepilot',
      isVisibility: true,
      tabName: 'Release (Pilot)',
      content: 'Release Content',
    },
    {
      id: 'operate',
      isVisibility: true,
      tabName: 'Operate',
      content: 'Operate Content',
    },
  ],
  clientAPIDefault: {
    'min-receipt-date': '2024-01-12',
    'max-receipt-date': '2025-12-31',
  },
  searchByAttributes: {
    'filter-by-attributes': {
      'search-criteria': '',
    },
  },
  filterByCatalogObjectIds: {
    'filter-by-catalog-object-ids': [],
  },
  dataProductFactory: {
    requestedDateID: 'mngdK76fde3171ed642998a64c8f6a5b45e61',
  },
  searchBoxRegex: {
    searchChars: /^[a-zA-Z0-9\-–*?'‘"[\]:()&!@#$%^/ ]+$/,
  },
};

export const DATA_DPR = [
  {
    requestId: 'SUBRE1043',
    requestDate: '15th May 2025',
    requestFrom: { name: 'Conor Baker', email: 'abey.alex@gds.ey.com' },
    approver: { name: 'Govert James', email: 'abey.alex@gds.ey.com' },
    productName: '-',
    action: 'Register',
    requestStatus: 'Accepted',
    dateModified: '-',
    note: '-',
  },
  {
    requestId: 'SUBRE1043',
    requestDate: '12th May 2025',
    requestFrom: { name: 'Taylor Brown', email: 'abey.alex@gds.ey.com' },
    approver: { name: 'Govert James', email: 'abey.alex@gds.ey.com' },
    productName: '-',
    action: 'Register',
    requestStatus: 'Accepted',
    dateModified: '21st May 2025',
    note: '-',
  },
  {
    requestId: 'SUBRE1029',
    requestDate: '10th May 2025',
    requestFrom: { name: 'Alisa Carpenter', email: 'abey.alex@gds.ey.com' },
    approver: { name: 'Alexander M', email: 'abey.alex@gds.ey.com' },
    productName: 'Fathom Global Food Map',
    action: '-',
    requestStatus: 'Accepted',
    dateModified: '20th May 2025',
    note: '-',
  },
  {
    requestId: 'SUBRE1029',
    requestDate: '2nd Feb 2025',
    requestFrom: { name: 'Prodd Smith', email: 'abey.alex@gds.ey.com' },
    approver: { name: 'Francis Paul', email: 'abey.alex@gds.ey.com' },
    productName: 'S&P Capital Trend',
    action: '-',
    requestStatus: 'Accepted',
    dateModified: '7th Feb 2025',
    note: '-',
  },
];

export const DATA_MDP = [
  {
    productName: 'LSEG Workshop',
    lifecycleStage: 'Operate',
    action: 'Update',
    productStatus: 'Published',
    lastUpdated: '7th Jun 2025',
  },
  {
    productName: 'The Business Research Company',
    lifecycleStage: 'Develop and Test',
    action: 'Update',
    productStatus: 'Draft',
    lastUpdated: '-',
  },
  {
    productName: 'ESG Restrictions for Investment Domain',
    lifecycleStage: 'Release (Pilot)',
    action: 'Update',
    productStatus: 'Pending',
    lastUpdated: '-',
  },
  {
    productName: 'AI/ML',
    lifecycleStage: 'Develop and Test',
    action: 'Update',
    productStatus: 'Published',
    lastUpdated: '5th May 2025',
  },
  {
    productName: 'The Business Research Company',
    lifecycleStage: 'Vision and Strategy',
    action: 'Update',
    productStatus: 'Pending',
    lastUpdated: '-',
  },
  {
    productName: 'Company.info Netherlands',
    lifecycleStage: 'Release (Pilot)',
    action: 'Update',
    productStatus: 'Draft',
    lastUpdated: '-',
  },
  {
    productName: 'UHNI  Investor Survey 2022 to 2024',
    lifecycleStage: 'Operate',
    action: 'Update',
    productStatus: 'Published',
    lastUpdated: '7th Feb 2025',
  },
];

export default content;
